export default "images/车灯开启情况-LED日间行车灯.png";